import type { ApplicationConfig } from './ApplicationConfig';
import { Stage } from './ApplicationConfig';

export const localConfig: ApplicationConfig = {
  apiUrl: 'http://localhost:3000',
  csAgentApiUrl: 'http://localhost:3001',
  internalApiUrl: 'http://localhost:8080',
  googleOAuthClientId: '639007308170-lcrsao9lgj3km159oo6uj2sjhs8tbrb8.apps.googleusercontent.com',
  apiKey: '75dd554a-2b38-4774-807d-a3d1a870c9e7',
  stage: Stage.LOCAL,
  sheetId: '1CNmHugwnAfmcFjMf1okeUJBsoUtFh7o-ktd7qXrcyEU',
  wpAdminUrl: 'https://dev.skin-seoul.com/wp-admin/',
  adminUrl: 'http://localhost:5173',
  n8nWebhookBaseUrl: 'https://dev-n8n.skin-seoul.work',
  slackTeamId: 'T06CKAJHMRU',
  logtoEndpoint: 'https://dev-auth.skin-seoul.com',
  logtoAppId: '9k0wksyunhb1wpkkppc5s',
  logtoStaffOrganizationId: 'qbhhenj8k9z0',
};
